module.exports = __webpack_public_path__ + "img/logo.5e4d26dd.webp";